import React from 'react';
import { SmallUppercase } from 'scy/text';
import { ThumbnailLinkCarousel } from 'scy/Carousel';
import { hidden, tablet_block } from 'scy/display.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function ProductInfoRecommendations({
  title,
  products,
  loading
}) {
  if (!products || !products.length) return null;

  return (
    <div className={`${hidden} ${tablet_block}`}>
      {!!title && <Title title={title} />}
      <ThumbnailLinkCarousel
        products={products}
        loading={loading}
        sliderSettings={{
          slidesToShow: 4,
          slidesToScroll: 4
        }}
      />
    </div>
  );
}

function Title({ title }) {
  return (
    <SmallUppercase
      tag="h3"
      marginClass={`${margin.top_0} ${margin.bottom_xs}`}
    >
      {title}
    </SmallUppercase>
  );
}
